// Accounting Period / Policy Month-Year are stored as YYYYMM on the wire but
// read as MM/YYYY everywhere in the UI (grid cells, header filters, the Add
// modal). These two helpers are the single conversion point.

// "202602" -> "02/2026". Anything that isn't six digits is returned as-is so a
// malformed value stays visible rather than silently blanking.
export function formatPeriod(value: string | null | undefined): string {
  if (!value) return "";
  const digits = value.replace(/\D/g, "");
  if (digits.length !== 6) return value;
  return `${digits.slice(4, 6)}/${digits.slice(0, 4)}`;
}

// "02/2026" (or "022026") -> "202602". Returns null when the input can't be a
// period, so callers can drop the criteria instead of sending garbage.
export function toPeriodCode(value: string | null | undefined): string | null {
  if (!value) return null;
  const digits = value.replace(/\D/g, "");
  if (digits.length !== 6) return null;
  // MM/YYYY typed by the user vs. YYYYMM pasted from the grid.
  if (value.includes("/")) return `${digits.slice(2, 6)}${digits.slice(0, 2)}`;
  return digits;
}
